

































import { Component, Prop } from 'vue-property-decorator';
import ActivitySessionAttendeeTable from '@activities/components/tables/activity-session-attendee-table/activity-session-attendee-table.vue';
import ActivitySessionAttendees from '@activities/mixins/activity-sessions-attendees';
import { mixins } from 'vue-class-component';
import { ActivitySessionAttendee } from '@activities/interfaces/activity-session-attendee';

@Component({
  name: 'bpc-profile-attendees',
  components: {
    'bpc-activity-session-attendee-table': ActivitySessionAttendeeTable,
  },
})
export default class ProfileAttendees extends mixins(ActivitySessionAttendees) {
  @Prop({ type: Boolean, default: true }) readonly showTabFilters: boolean;
  @Prop({ type: Boolean, default: false }) readonly showOrderBy: boolean;
  @Prop({ type: Boolean, default: false }) readonly showPagination: boolean;
  @Prop({ type: Boolean, default: false }) readonly withSearch: boolean;

  // LIFECYCLE
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}

  // DATA
  declare selectedSessionToAttend: number;
  declare showSessionAttendeeModal: boolean;
  // COMPUTED
  get contactId() {
    return this.$authorizationService.getContactId();
  }
  get filterByContactId() {
    return [{ filterField: 'attendee_id', modelField: null, value: this.contactId }];
  }

  // METHODS
  onContinueAttendeePayment(attendee: ActivitySessionAttendee) {
    this.selectedSessionToAttend = attendee.activity_session_id;
    this.showSessionAttendeeModal = true;
    console.log('onContinueAttendeePayment', attendee);
  }
}
